<template>
  <nav class="nav-panel" :class="{ 'mobile-nav': isMobile }">
    <div class="wrap">
      <div class="logo" />
      <div v-if="isMobile" class="menu-toggle" :class="{ 'active': showMobileMenu }" @click="toggleMobileMenu">
        <span />
        <span />
        <span />
      </div>
      <ul class="nav-list" :class="{ 'mobile-menu': isMobile, 'show': showMobileMenu }">
        <li class="nav">
          <a href="https://creatinf.com/">{{ getNavTranslation(currentLang, 'home') }}</a>
        </li>
        <li class="nav has-submenu">
          <a @click="toggleSubmenu('feature')">{{ getNavTranslation(currentLang, 'features') }}
            <img src="../assets/down.svg" alt="向下箭头" class="arrow-icon" :class="{ 'rotated': submenuStates.feature }">
          </a>
          <ul class="submenu" :class="{ 'show': activeSubmenu === 'feature' }">
            <li>
              <a href="https://creatinf.com/RemoveBackground/"><img src="../assets/抠图.svg" alt="Icon"
                  class="submenu-icon">{{ getNavTranslation(currentLang, 'removeBackground') }}</a>
            </li>
            <li>
              <a href="https://creatinf.com/MattingPoints/"><img src="../assets/选点.svg" alt="Icon"
                  class="submenu-icon">{{ getNavTranslation(currentLang, 'mattingPoints') }}</a>
            </li>
            <li>
              <a href="https://creatinf.com/Image_ReFocus/"><img src="../assets/对焦.svg" alt="Icon"
                  class="submenu-icon">{{ getNavTranslation(currentLang, 'imageRefocus') }}</a>
            </li>
            <li>
              <a href="https://creatinf.com/Image_Convert"><img src="../assets/格式转换.svg" alt="Icon"
                  class="submenu-icon">{{ getNavTranslation(currentLang, 'imageConvert') }}</a>
            </li>
            <li>
              <a href="https://creatinf.com/OCR/"><img src="../assets/OCR.svg" alt="Icon" class="submenu-icon">{{ getNavTranslation(currentLang, 'ocr') }}</a>
            </li>
            <li>
              <a href="https://creatinf.com/Super-resolution/"><img src="../assets/无损放大.svg" alt="Icon"
                  class="submenu-icon">{{ getNavTranslation(currentLang, 'superResolution') }}</a>
            </li>
            <li>
              <a href="https://creatinf.com/Image_To_SVG"><img src="../assets/位图转矢量图.svg" alt="Icon"
                  class="submenu-icon">{{ getNavTranslation(currentLang, 'imageToSvg') }}</a>
            </li>
            <li>
              <a href="https://creatinf.com/AI-Eraser/"><img src="../assets/AI消除笔.svg" alt="Icon"
                  class="submenu-icon">{{ getNavTranslation(currentLang, 'aiEraser') }}</a>
            </li>
            <li>
              <a href="https://creatinf.com/AI-Image-Editor/"><img src="../assets/ai生图.svg" alt="Icon"
                  class="submenu-icon">{{ getNavTranslation(currentLang, 'aiImageEditor') }}</a>
            </li>
             <li>
              <a href="https://creatinf.com/AI-Image-Generate/"><img src="../assets/文生图模型.svg" alt="Icon"
                  class="submenu-icon">{{ getNavTranslation(currentLang, 'aiImageGenerate') }}</a>
            </li>
          </ul>
        </li>
        <li class="nav has-submenu">
          <a @click="toggleSubmenu('editor')">{{ getNavTranslation(currentLang, 'editor') }}
            <img src="../assets/down.svg" alt="向下箭头" class="arrow-icon" :class="{ 'rotated': submenuStates.editor }">
          </a>
          <ul class="submenu" :class="{ 'show': activeSubmenu === 'editor' }">
            <li>
              <a href="https://creatinf.com/Mind_Map/#/"><img src="../assets/思维导图.svg" alt="Icon"
                  class="submenu-icon">{{ getNavTranslation(currentLang, 'mindMap') }}</a>
            </li>
            <li>
              <a href="https://creatinf.com/PPT-Editor/"><img src="../assets/ppt.svg" alt="Icon"
                  class="submenu-icon">{{ getNavTranslation(currentLang, 'pptEditor') }}</a>
            </li>
            <li>
              <a href="https://creatinf.com/Canvas/"><img src="../assets/产品海报.png" alt="Icon"
                  class="submenu-icon">{{ getNavTranslation(currentLang, 'posterEditor') }}</a>
            </li>
            <li>
              <a href="https://creatinf.com/AI-Chat/"><img src="../assets/AI聊天-copy 1.svg" alt="Icon"
                  class="submenu-icon">{{ getNavTranslation(currentLang, 'aiChat') }}</a>
            </li>
          </ul>
        </li>
        <li class="nav">
          <a href="https://creatinf.com/CustomerService/">{{ getNavTranslation(currentLang, 'customerService') }}</a>
        </li>

        <li class="nav">
          <a href="https://creatinf.com/Price/">{{ getNavTranslation(currentLang, 'price') }}</a>
        </li>
      </ul>

      <li class="nav user-profile" style="margin-left: auto;">
        <div class="relative" v-if="userInfo">
          <!-- 如果已登录，显示图标并控制浮窗的显示 -->
          <div class="cursor-pointer flex items-center" @click="toggleUserInfo" @mouseenter="handleMouseEnter">
            <font-awesome-icon :icon="['fas', 'user-circle']" class="text-xl"
              style="font-size: 30px; margin-bottom: 10px;" />
          </div>
          <transition name="user-info-popup" @after-enter="onTransitionEnd">
            <div v-if="showUserInfo" class="user-info-popup">
              <div class="user-header">
                <font-awesome-icon :icon="['fas', 'user-circle']" class="user-avatar" />
                <div class="user-details">
                  <h3 class="username">{{ userInfo.username }}</h3>
                  <span class="user-status">{{ getNavTranslation(currentLang, 'loggedIn') }}</span>
                </div>
              </div>
              
              <div class="user-stats">
                <div class="stat-item">
                  <span class="stat-label">{{ getNavTranslation(currentLang, 'remainingQuota') }}</span>
                  <span class="stat-value">{{ userInfo.remaining_images }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">{{ getNavTranslation(currentLang, 'dailyFreeQuota') }}</span>
                  <span class="stat-value">{{ userInfo.daily_free_images }}</span>
                </div>
              </div>

              <div class="user-actions">
                <button @click="checkUserInfo" class="action-btn refresh-btn">
                  <font-awesome-icon :icon="['fas', 'sync-alt']" class="fa-icon" />
                  {{ getNavTranslation(currentLang, 'refreshInfo') }}
                </button>
                <button @click="goToLogin" class="action-btn login-btn">
                  <font-awesome-icon :icon="['fas', 'sign-in-alt']" class="fa-icon" />
                  {{ getNavTranslation(currentLang, 'loginPage') }}
                </button>
                <button @click="goToInvitationPage" class="action-btn invite-btn">
                  <font-awesome-icon :icon="['fas', 'key']" class="fa-icon" />
                  {{ getNavTranslation(currentLang, 'enterInvitationCode') }}
                </button>
                <button @click="handleLogout" class="action-btn logout-btn">
                  <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="fa-icon" />
                  {{ getNavTranslation(currentLang, 'logout') }}
                </button>
              </div>
            </div>
          </transition>

        </div>
        <div v-else>
          <!-- 如果未登录，显示登录按钮 -->
      <li class="nav has-submenu">
        <a href="https://creatinf.com/Login">{{ getNavTranslation(currentLang, 'login') }}</a>
      </li>
    </div>
    </li>
    </div>
  </nav>
</template>

<script>
import axios from 'axios';
import { ElMessage } from 'element-plus';
import { getNavTranslation, NavLanguageStorage } from '@/utils/navTranslations';

export default {
  name: 'NavPanel',
  data() {
    return {
      isMobile: false,
      activeSubmenu: null,  // 默认没有菜单展开
      showMobileMenu: false,
      submenuStates: {
        feature: false,
        editor: false
      },
      showUserInfo: false,
      userInfo: null,// 将由 checkUserInfo 方法填充
      currentLang: 'zh', // 当前语言
      api: axios.create({
        baseURL: 'https://creatinf.com',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        }
      })
    }
  },
  mounted() {
    this.setupApiInterceptors();
    this.checkMobile();
    this.checkUserInfo();
    this.initLanguage();
    window.addEventListener('resize', this.checkMobile);
    document.addEventListener('click', this.handleClickOutside); // 监听点击外部关闭子菜单
    document.addEventListener('click', this.handleOutsideClick); // 监听点击外部关闭用户信息浮窗

  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
    document.removeEventListener('click', this.handleClickOutside); // 移除事件监听
    document.removeEventListener('click', this.handleOutsideClick); // 移除事件监听

  },
  methods: {
    // 获取导航栏翻译文本
    getNavTranslation(lang, key) {
      return getNavTranslation(lang, key);
    },
    
    // 初始化语言设置
    initLanguage() {
      // 从localStorage获取保存的语言设置
      const savedLang = NavLanguageStorage.getLanguage();
      if (savedLang && savedLang !== 'current') {
        this.currentLang = savedLang;
      } else {
        // 根据当前域名判断语言
        const currentDomain = window.location.hostname;
        if (currentDomain.includes('en.creatinf.com')) {
          this.currentLang = 'en';
        } else if (currentDomain.includes('jp.creatinf.com')) {
          this.currentLang = 'ja';
        } else {
          this.currentLang = 'zh';
        }
      }
    },
    
    goToInvitationPage() {
    window.location.href = 'https://creatinf.com/invitation';
  },
    async handleLogout() {
  try {
    console.log('Logging out...');
    const response = await fetch('https://creatinf.com/logout', {
      method: 'POST',
      credentials: 'include', // 确保发送 Cookie
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();
    if (data.success) {
      // 清空 userInfo
      this.userInfo = null;

      // 清除 localStorage 中的用户信息
      localStorage.removeItem('userInfo');
      console.log('Logout successful');

      // 显示提示信息
      ElMessage.success('已成功登出');

      // 500ms后刷新界面
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } else {
      ElMessage.error('登出失败，请重试');
    }
  } catch (error) {
    console.error('Logout error:', error);
    ElMessage.error('登出失败：' + (error.message || '未知错误'));
  }
},
    onTransitionEnd() {
      if (!this.showUserInfo) {
        // 动画结束后隐藏逻辑
      }
    },
    handleMouseEnter() {
      if (!this.showUserInfo) {
        this.showUserInfo = true; // 鼠标移入时显示浮窗
      }
    },
    goToLogin() {
      window.location.href = 'https://creatinf.com/Login';
    },
    handleClickOutside(event) {
    // 检查点击是否发生在菜单外部
    const menu = this.$el.querySelector('.nav-list');
    if (menu && !menu.contains(event.target)) {
      this.activeSubmenu = null; // 点击菜单外部，收起所有子菜单

      // 重置所有子菜单的箭头图标状态
      for (let key in this.submenuStates) {
        this.submenuStates[key] = false;
      }
    }
  },
    handleOutsideClick(event) {
      const userProfile = this.$el.querySelector('.user-profile');
      if (userProfile && !userProfile.contains(event.target)) {
        this.showUserInfo = false; // 点击其他区域时关闭浮窗 用户图标
      }
    },
    toggleUserInfo() {
      this.showUserInfo = !this.showUserInfo; // 切换显示状态
    },
    setupApiInterceptors() {
      this.api.interceptors.response.use(
        response => response,
        error => {
          if (error.response?.status === 401) {
            localStorage.removeItem('userInfo');
            this.userInfo = null;
          }
          return Promise.reject(error);
        }
      );
    },
    async checkUserInfo() {
      try {
        const storedUserInfo = localStorage.getItem('userInfo');
        if (storedUserInfo) {
          const parsedInfo = JSON.parse(storedUserInfo);
          console.log('Found stored user info:', parsedInfo);
        }

        const response = await this.api.get('/user_info');
        if (response.data.success) {
          this.userInfo = {
            username: response.data.data.username,
            phone: response.data.data.phone,
            daily_free_images: response.data.data.daily_free_images,
            remaining_images: response.data.data.remaining_images,
          };
          localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
          console.log('User info verified from server:', this.userInfo);
        }
      } catch (error) {
        if (error.response?.status === 401) {
          console.log('Session expired or not logged in, clearing local data');
          this.userInfo = null;
          localStorage.removeItem('userInfo');
        } else {
          console.error('Error fetching user info:', error);
        }
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
      document.body.classList.toggle('menu-open', this.showMobileMenu); 
    },
    toggleSubmenu(submenu) {
      // 如果当前点击的菜单已经展开，收起它；否则展开它并收起其他菜单
      if (this.activeSubmenu === submenu) {
        this.activeSubmenu = null; // 当前菜单已打开，点击后收起
        this.submenuStates[submenu] = false; // 关闭箭头旋转
      } else {
        this.activeSubmenu = submenu; // 打开当前菜单，关闭其他菜单
        this.submenuStates[submenu] = true; // 开启箭头旋转
      }
    },
   
  }
}
</script>

<style scoped>
.logo {
  background: url(../assets/logo.png) 10% / contain no-repeat;
  height: 50px;
  width: 200px;
  margin-right: 32px;
  flex: 0 0 auto;
}
/* Main Navigation Panel */
.nav-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 0 2rem;
  height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.nav-panel .wrap {
  display: flex;
  align-items: center;
  width: 100%;
}

.logo {
  width: 120px;
  height: 40px;
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 2rem;
}

/* Navigation List */
.nav-list {
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.nav {
  position: relative;
  margin: 0 1rem;
  list-style: none;
}

.nav a {
  display: flex;
  align-items: center;
  color: #333;
  text-decoration: none;
  font-size: 16px;
  padding: 0.5rem 0.8rem;
  transition: color 0.3s ease;
  cursor: pointer;
}

.nav a:hover {
  color: #2a6ae8;
}

/* Submenu styles */
.has-submenu {
  position: relative;
}

.submenu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  padding: 0.5rem 0;
  min-width: 200px;
  display: none;
  z-index: 100;
}

.submenu.show {
  display: block;
  animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.submenu li {
  list-style: none;
}

.submenu li a {
  display: flex;
  align-items: center;
  padding: 0.7rem 1rem;
  color: #333;
  font-size: 14px;
  transition: background-color 0.2s;
}

.submenu li a:hover {
  background-color: #f5f7fa;
  color: #2a6ae8;
}

.submenu-icon {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

.arrow-icon {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  transition: transform 0.3s ease;
}

.arrow-icon.rotated {
  transform: rotate(180deg);
}

/* User Profile */
.user-profile {
  position: relative;
  display: flex;
  align-items: center;
}

/* 优化后的用户信息弹窗样式 */
.user-info-popup {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  padding: 1.5rem;
  min-width: 280px;
  z-index: 1000;
  border: 1px solid #e1e5e9;
}

.user-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f0f0f0;
}

.user-avatar {
  font-size: 2.5rem;
  color: #2a6ae8;
  margin-right: 0.75rem;
}

.user-details {
  flex: 1;
}

.username {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  line-height: 1.2;
}

.user-status {
  font-size: 0.85rem;
  color: #28a745;
  font-weight: 500;
}

.user-stats {
  margin-bottom: 1rem;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.stat-label {
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
}

.stat-value {
  font-size: 0.9rem;
  color: #2a6ae8;
  font-weight: 600;
}

.user-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.action-btn {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  text-align: left;
  width: 100%;
}

.refresh-btn {
  color: #2a6ae8;
}

.refresh-btn:hover {
  background-color: #f0f7ff;
  color: #1d4fa0;
}

.login-btn {
  color: #28a745;
}

.login-btn:hover {
  background-color: #f0fff4;
  color: #1e7e34;
}

.invite-btn {
  color: #ffc107;
}

.invite-btn:hover {
  background-color: #fffbf0;
  color: #e0a800;
}

.logout-btn {
  color: #dc3545;
}

.logout-btn:hover {
  background-color: #fff5f5;
  color: #c82333;
}

.fa-icon {
  margin-right: 0.5rem;
  width: 14px;
}

.nav-panel::after {
  content: '';
  position: fixed;
  top: 70px; /* Match the height of your nav panel */
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px); /* For Safari */
  z-index: 999; /* Just below the nav-list z-index */
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  pointer-events: none;
}
/* Make sure mobile menu stays above the overlay */
.nav-list.show {
  z-index: 1000;
}

/* User info popup transition */
.user-info-popup-enter-active,
.user-info-popup-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.user-info-popup-enter-from,
.user-info-popup-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.menu-toggle {
  display: none;
}
.submenu.show {
  border-top: 2px solid #0056b3;
}

/* If you specifically want it for the editor tools dropdown */
.submenu.show[class*="editor"] {
  border-top: 2px solid #0056b3;
}

/* For the user info popup as well, if needed */
.user-info-popup {
  border-top: 2px solid #0056b3;
}
/* Mobile navigation */
@media (max-width: 768px) {
  .nav-panel {
    padding: 0 1rem;
  }

  .menu-toggle {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 24px;
    height: 20px;
    cursor: pointer;
    margin-right: 15px; /* Add right margin instead of left auto */
    margin-left: 0; /* Reset any left margin */
    order: -1; /* This will place it before other elements in the flex container */
  }

  .menu-toggle span {
    width: 100%;
    height: 3px;
    background-color: #333;
    border-radius: 3px;
    transition: all 0.3s ease;
  }

  .menu-toggle.active span:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
  }

  .menu-toggle.active span:nth-child(2) {
    opacity: 0;
  }

  .menu-toggle.active span:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
  }

  .nav-list {
    position: absolute;
    top: 70px;
    left: 0;
    right: 0;
    background-color: #fff;
    flex-direction: column;
    padding: 1rem 0;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    display: none;
  }

  .nav-list.show {
    display: flex;
  }

  .nav {
    margin: 0;
  }

  .nav a {
    padding: 1rem 1.5rem;
  }

  .submenu {
    position: static;
    box-shadow: none;
    padding-left: 1.5rem;
    min-width: auto;
    border-radius: 0;
  }

  .submenu li a {
    padding: 0.8rem 1.5rem;
  }

  .user-profile {
    margin: 0.5rem 1.5rem;
  }

  .user-info-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 320px;
  }
}
</style>
